// define the state model
export const Menu = {
  // is the menu showing?
  open: false,
};
